import { render } from "./PhotoUploadButton.vue?vue&type=template&id=4d23be37&scoped=true"
import script from "./PhotoUploadButton.vue?vue&type=script&lang=js"
export * from "./PhotoUploadButton.vue?vue&type=script&lang=js"

import "./PhotoUploadButton.vue?vue&type=style&index=0&id=4d23be37&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d23be37"]])

export default __exports__